/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Team_Manager_Load_Groups_FailedInputs */

const en_team_manager_load_groups_failed = /** @type {(inputs: Team_Manager_Load_Groups_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error loading groups. ${i?.error}`)
};

const fr_team_manager_load_groups_failed = /** @type {(inputs: Team_Manager_Load_Groups_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Erreur lors du chargement des groupes. ${i?.error}`)
};

const de_team_manager_load_groups_failed = /** @type {(inputs: Team_Manager_Load_Groups_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fehler beim Laden der Gruppen. ${i?.error}`)
};

const it_team_manager_load_groups_failed = /** @type {(inputs: Team_Manager_Load_Groups_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Errore durante il caricamento dei gruppi. ${i?.error}`)
};

const ru_team_manager_load_groups_failed = /** @type {(inputs: Team_Manager_Load_Groups_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ошибка загрузки групп. ${i?.error}`)
};

const es_team_manager_load_groups_failed = /** @type {(inputs: Team_Manager_Load_Groups_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error al cargar grupos. ${i?.error}`)
};

const zh_cn2_team_manager_load_groups_failed = /** @type {(inputs: Team_Manager_Load_Groups_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`加载组时出错。${i?.error}`)
};

const ja_team_manager_load_groups_failed = /** @type {(inputs: Team_Manager_Load_Groups_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`グループの読み込み中にエラーが発生しました。${i?.error}`)
};

const hi_team_manager_load_groups_failed = /** @type {(inputs: Team_Manager_Load_Groups_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`समूह लोड करने में त्रुटि। ${i?.error}`)
};

const pt_pt2_team_manager_load_groups_failed = /** @type {(inputs: Team_Manager_Load_Groups_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Erro ao carregar grupos. ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Error loading groups. {error}" |
*
* @param {Team_Manager_Load_Groups_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_load_groups_failed = /** @type {((inputs: Team_Manager_Load_Groups_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Load_Groups_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_manager_load_groups_failed(inputs)
	if (locale === "de") return de_team_manager_load_groups_failed(inputs)
	if (locale === "it") return it_team_manager_load_groups_failed(inputs)
	if (locale === "ru") return ru_team_manager_load_groups_failed(inputs)
	if (locale === "es") return es_team_manager_load_groups_failed(inputs)
	if (locale === "zh-CN") return zh_cn2_team_manager_load_groups_failed(inputs)
	if (locale === "ja") return ja_team_manager_load_groups_failed(inputs)
	if (locale === "hi") return hi_team_manager_load_groups_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_team_manager_load_groups_failed(inputs)
	return en_team_manager_load_groups_failed(inputs)
});